import { render, staticRenderFns } from "./jb.vue?vue&type=template&id=43aedce2&scoped=true&"
import script from "./jb.vue?vue&type=script&lang=js&"
export * from "./jb.vue?vue&type=script&lang=js&"
import style0 from "./jb.vue?vue&type=style&index=0&id=43aedce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aedce2",
  null
  
)

export default component.exports